import React from "react";

interface LogoProps {
  className?: string;
  variant?: "light" | "dark";
}

export const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center select-none ${className}`}>
      <img
        src="https://vibe.filesafe.space/1786557593842074307/attachments/4b27aea3-e49e-450d-a160-603092ebfb1e.png?w=200&q=60"
        srcSet="https://vibe.filesafe.space/1786557593842074307/attachments/4b27aea3-e49e-450d-a160-603092ebfb1e.png?w=150&q=50 150w, https://vibe.filesafe.space/1786557593842074307/attachments/4b27aea3-e49e-450d-a160-603092ebfb1e.png?w=200&q=60 200w, https://vibe.filesafe.space/1786557593842074307/attachments/4b27aea3-e49e-450d-a160-603092ebfb1e.png?w=300&q=70 300w"
        sizes="(max-width: 640px) 150px, (max-width: 1024px) 200px, 250px"
        alt="Muscle Junk Removal Davie FL"
        className="h-24 sm:h-28 md:h-32 w-auto object-contain"
        width={200}
        height={80}
        decoding="async"
        loading="eager"
      />
    </div>
  );
};
